const Footer = () => {
  return (
    <footer className="py-20 bg-gray-800">
      <h4 className="text-center dark:text-gray-300 font-semibold text-xs">
        Copyright Artsu.me. All rights reserved.
      </h4>
    </footer>
  );
};

export default Footer;
